export default "__VITE_ASSET__BbuP1jaR__"